import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  /* ── Public (Auth) ── */
  {
    path: '/login',
    name: 'login',
    component: () => import('@/features/auth/AuthShell.vue'),
    meta: { public: true },
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('@/features/auth/AuthShell.vue'),
    meta: { public: true },
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('@/features/auth/OnboardingPage.vue'),
  },

  /* ── App Shell ── */
  {
    path: '/',
    component: () => import('@/components/layout/AppShell.vue'),
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/features/dashboard/DashboardPage.vue'),
      },

      /* Money */
      {
        path: 'money',
        component: () => import('@/features/money/MoneyLayout.vue'),
        redirect: '/money/overview',
        children: [
          {
            path: 'overview',
            name: 'money-overview',
            component: () => import('@/features/money/pages/FinanceOverviewPage.vue'),
          },
          {
            path: 'expenses',
            name: 'expenses',
            component: () => import('@/features/money/pages/ExpensesPage.vue'),
          },
          {
            path: 'income',
            name: 'income',
            component: () => import('@/features/money/pages/IncomePage.vue'),
          },
          {
            path: 'bills',
            name: 'bills',
            component: () => import('@/features/money/pages/BillsPage.vue'),
          },
          {
            path: 'budgets',
            name: 'budgets',
            component: () => import('@/features/money/pages/BudgetsPage.vue'),
          },
          {
            path: 'savings',
            name: 'savings',
            component: () => import('@/features/money/pages/SavingsPage.vue'),
          },
          {
            path: 'balances',
            name: 'balances',
            component: () => import('@/features/money/pages/BalancesPage.vue'),
          },
        ],
      },

      /* Tasks */
      {
        path: 'tasks',
        name: 'tasks',
        component: () => import('@/features/tasks/TasksPage.vue'),
      },

      /* Calendar */
      {
        path: 'calendar',
        name: 'calendar',
        component: () => import('@/features/calendar/CalendarPage.vue'),
      },

      /* Pantry (Shopping + Inventory) */
      {
        path: 'pantry',
        component: () => import('@/features/pantry/PantryLayout.vue'),
        redirect: '/pantry/shopping',
        children: [
          {
            path: 'shopping',
            name: 'shopping',
            component: () => import('@/features/pantry/pages/ShoppingPage.vue'),
          },
          {
            path: 'inventory',
            name: 'inventory',
            component: () => import('@/features/pantry/pages/InventoryPage.vue'),
          },
        ],
      },

      /* Reminders */
      {
        path: 'reminders',
        name: 'reminders',
        component: () => import('@/features/reminders/RemindersPage.vue'),
      },

      /* Notes */
      {
        path: 'notes',
        name: 'notes',
        component: () => import('@/features/notes/NotesPage.vue'),
      },

      /* Wishlist (personal) */
      {
        path: 'wishlist',
        name: 'wishlist',
        component: () => import('@/features/wishlist/WishlistPage.vue'),
      },

      /* Journal (personal) */
      {
        path: 'journal',
        name: 'journal',
        component: () => import('@/features/journal/JournalPage.vue'),
      },

      /* Boards (both scopes) */
      {
        path: 'boards',
        name: 'boards',
        component: () => import('@/features/boards/BoardsPage.vue'),
      },
      {
        path: 'boards/:id',
        name: 'board-detail',
        component: () => import('@/features/boards/BoardDetailPage.vue'),
      },

      /* Trackers (both scopes) */
      {
        path: 'trackers',
        name: 'trackers',
        component: () => import('@/features/trackers/TrackersPage.vue'),
      },
      {
        path: 'trackers/:id',
        name: 'tracker-detail',
        component: () => import('@/features/trackers/TrackerDetailPage.vue'),
      },

      /* Contacts (household) */
      {
        path: 'contacts',
        name: 'contacts',
        component: () => import('@/features/contacts/ContactsPage.vue'),
      },

      /* Documents (household) */
      {
        path: 'documents',
        name: 'documents',
        component: () => import('@/features/documents/DocumentsPage.vue'),
      },

      /* Settings */
      {
        path: 'settings',
        name: 'settings',
        component: () => import('@/features/settings/SettingsPage.vue'),
      },
    ],
  },

  /* ── Catch-all ── */
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition ?? { top: 0 }
  },
})

/* Auth guard is set up in main.ts via setupAuthGuard() */

export default router
